<div class="eau-page-header">
    <h1 class="eau-page-header--title">{{getTitle()}}</h1>
    <div class="eau-page-header--subtitle">{{getSubtitle()}}</div>
</div>